export default __webpack_public_path__ + "static/media/Performance-mareting-img1.94c1aa42.png";